import { calculateGrade, cn, getColorByScore } from "@/lib/utils";
import { SubCategoryResult as TSubCategoryResult } from "@/schema/improvement-proposal/SubCategoryResult";
import { useTranslation } from "react-i18next";


interface SubCategoryResultProps {
  isLast: boolean;
  subCategoryResult: TSubCategoryResult;
}

function SubCategoryResult({
  isLast,
  subCategoryResult: { id, content, proposal_note, score },
}: SubCategoryResultProps) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-[max-content,1fr]">
      <div className="pl-[24px] overflow-hidden">
        <div className="w-[20px] h-[40%] bg-[transparent] border-l-[2px] border-b-[2px] rounded-bl-[16px] border-[#E3E4E5]" />
        {!isLast && (
          <div className="w-[20px] h-[100%] bg-[transparent] border-l-[2px] border-[#E3E4E5] mt-[-60%]" />
        )}
      </div>

      <div
        className={cn(
          "grid grid-cols-[200px,repeat(2,max-content),1fr] border-[#E3E4E5]",
          !isLast && "border-b-[1px]",
        )}
      >
        <div className="py-[16px] px-[24px]">
          <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium">
            {content}
          </span>
        </div>
        <div className="py-[16px] px-[24px]">
        <div>
            <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-normal">
              {t("score")}{" "}
            </span>
            <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-bold">
              {score ?? '--'}
            </span>
          </div>
          <div>
            <div className="bg-cool-gray-200 w-[100px] h-[8px] rounded-[8px]">
              <div
                className="bg-cyan-500 rounded-[8px] h-[8px]"
                style={{
                  width: `${score ?? 0}%`,
                }}
              />
            </div>
          </div>
        </div>
        <div className="py-[16px] px-[24px]">
          <div>
            <span
              className={cn(
                getColorByScore(score),
                "text-[14px] leading-[20px]  font-bold",
              )}
            >
              {calculateGrade(score)}
            </span>
          </div>
          <div>
            <span className="text-cool-gray-500 text-[14px] leading-[20px] font-normal">
              {t("judgement")}
            </span>
          </div>
        </div>
        <div className="py-[16px] px-[24px]">
          <span className="text-cool-gray-700 text-[14px] leading-[20px] font-medium font-sans">
            {proposal_note}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SubCategoryResult;
